<script lang="ts">
export interface ProseUlProps {
  class?: any
}

export interface ProseUlSlots {
  default: (props?: object) => unknown
}
</script>

<script setup lang="ts">
const props = defineProps<ProseUlProps>()
defineSlots<ProseUlSlots>()
</script>

<template>
  <ul
    class="my-1.5 list-disc ps-6"
    :class="props.class"
  >
    <slot />
  </ul>
</template>
